module.exports = __webpack_public_path__ + "static/media/facebook.c9e1625b.svg";